import { OmitStrict } from "@amx/ux-twoui-utils";
import React from "react";
import { ListItemCanvas, ListItemCanvasProps } from "../../../../components/Lists/ListItems/shared/ListItemCanvas";
import { Stack } from "../../../../components/Stacks/Stack/Stack";
import { useComponentLogger } from "../../../../shared/logging";
import { validateProps } from "../../../../shared/props";
import { Pill, PillProps } from "../../Pill/Pill/Pill";
import { PillContainer, PillContainerBaseProps, PillContainerCustomExpandProps } from "../../Pill/PillContainer/PillContainer";

export interface PillContainerListItemProps extends ListItemCanvasProps {
    readonly pills: readonly PillProps[];
    readonly pillContainerProps: OmitStrict<(PillContainerBaseProps & PillContainerCustomExpandProps), "children" | "useCustomExpand">;
}

export const PillContainerListItem: React.FC<PillContainerListItemProps> = ({
    pills,
    groupSpacerNestingDepth,
    backgroundColor,
    onClickProps,
    pillContainerProps,
    ...otherProps
}) => {
    useComponentLogger("PillContainerListItem", otherProps.id);

    validateProps("PillContainerListItem", otherProps);

    return (
        <ListItemCanvas
            groupSpacerNestingDepth={groupSpacerNestingDepth}
            backgroundColor={backgroundColor}
            onClickProps={onClickProps}
            {...otherProps}
        >
            <Stack padding="0 16px">
                <PillContainer
                    useCustomExpand={true}
                    {...pillContainerProps}
                >
                    {pills.map((pill, index) => <Pill {...pill} key={index} />)}
                </PillContainer>
            </Stack>
        </ListItemCanvas>
    );
};
